import { render, staticRenderFns } from "./AtomProjectSliderBackground.vue?vue&type=template&id=7ffe60a4&scoped=true&"
import script from "./AtomProjectSliderBackground.vue?vue&type=script&lang=js&"
export * from "./AtomProjectSliderBackground.vue?vue&type=script&lang=js&"
import style0 from "./AtomProjectSliderBackground.vue?vue&type=style&index=0&id=7ffe60a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe60a4",
  null
  
)

export default component.exports